import { render, staticRenderFns } from "./UICheckbox.vue?vue&type=template&id=3dfed1d3&scoped=true&"
import script from "./UICheckbox.vue?vue&type=script&lang=js&"
export * from "./UICheckbox.vue?vue&type=script&lang=js&"
import style0 from "./UICheckbox.vue?vue&type=style&index=0&id=3dfed1d3&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfed1d3",
  null
  
)

export default component.exports